<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row margin-bottom-20">
                <div class="col-xs-7 col-md-7">
                    <ol class="breadcrumb">
                        <li><router-link :to="{name:'calendar'}">Home</router-link></li>
                        <li><router-link :to="{name:'marketing'}">{{$t('views.marketing.title')}}</router-link></li>
                        <li class="active">{{$t('views.showcases.title')}}</li>
                    </ol>
                </div>
                <div class="col-xs-5 col-md-5 text-right">
                    <button class="btn btn-default" @click="$router.push({name:'marketing'})">
                        <i class="las la-undo"></i>
                        <span class="button-text">{{$t('navigation.back_to_marketing')}}</span>
                    </button>
                </div>
            </div>
            <hr>
            <div class="row margin-bottom-20">
                <div class="col-xs-12 col-md-7">
                    <h1 class="h2 margin-0">{{$t('views.showcases.title')}}</h1>
                </div>
                <div class="col-xs-12 col-md-5 text-right">
                    <button
                            class="btn btn-primary btn-action-mobile"
                            @click="showAddShowcaseModal"
                    >
                        <i class="las la-plus"></i>
                        <span class="button-text">{{$t('views.showcases.new_showcase')}}</span>
                    </button>
                </div>
            </div>
            <!-- TODO translate this page -->
            <Pagination
                    v-show="numberPagesShowcases > 1"
                    :page-count="numberPagesShowcases"
                    :click-handler="paginateCallback" />
            <ShowcaseTable v-if="showcases.length > 0" :showcases="showcases"></ShowcaseTable>
            <div v-else>
                <span class="text-muted">{{ $t('views.showcases.not_found') }}</span>
            </div>
        </div>
        <AddShowcaseModal v-show="addShowcaseModalVisible" :visible="addShowcaseModalVisible" @close-showcase-modal="addShowcaseModalVisible=false"></AddShowcaseModal>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import Pagination from "../components/common/Pagination";
    import ShowcaseTable from "../components/showcase/ShowcaseTable";
    import {LIMIT_RECORDS_API} from "../common/constants";
    import {getShowcases} from "../api";
    import {Utils} from "../common/utils";
    import i18n from "../i18n";
    import AddShowcaseModal from "../components/modal/AddShowcaseModal";

    export default {
        title: i18n.t('views.showcases.title'),
        name: "Showcases",
        components: { ContainerWithMenu, SpinnerLoader, Pagination, ShowcaseTable, AddShowcaseModal},
        async mounted() {
            this.getShowcases();

            this.loading = true;
            this.errorMessage = "";
        },
        data: () => {
            return {
                showcases: [],
                countShowcases: 0,
                limitShowcases: LIMIT_RECORDS_API,
                currentPageVideo: 1,
                loading: false,
                addShowcaseModalVisible: false
            }
        },
        methods: {
            async getShowcases(page = 1) {
                this.loading = true;
                try {
                    let showcasesResponse = await getShowcases(page);
                    this.countShowcases = showcasesResponse.count;
                    this.showcases = showcasesResponse.results;

                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            showAddShowcaseModal() {
                this.addShowcaseModalVisible = true;
            },
            paginateCallback(pageNum) {
                this.getShowcases(pageNum)
            }
        },
        computed: {
            numberPagesShowcases: function () {
                return Utils.getNumberPageByCountLimit(this.countShowcases, this.limitShowcases);
            }
        }
    };
</script>